<template>
  <Teleport
    :disabled="props.teleportDisabled"
    :to="props.targetElement"
  >
    <SalesFloorWidgetTransition>
      <SalesFloorWidget />
    </SalesFloorWidgetTransition>
  </Teleport>
</template>

<script setup>

import {
  defineAsyncComponent,
} from 'vue';

import SalesFloorWidgetTransition from '../features/SalesFloorWidgetTransition';

// eslint-disable-next-line
const props = defineProps({
  path: { type: String, required: true },
  targetElement: { type: String, required: true },
  teleportDisabled: { type: Boolean, required: true },
});

const SalesFloorWidget = defineAsyncComponent(() => import(/* webpackChunkName: 'SalesFloorWidget' */ `${props.path}`));
</script>

<style lang="scss" brand="mcom" >
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.sf-virtual-advisor--stylist-title {
  @include body(heavy);
}
</style>

<style lang="scss" brand="bcom" >
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.sf-virtual-advisor--stylist-title {
  @include label;
}
</style>

<style lang="scss" >
div.disable-sf-widget, a.disable-sf-widget {
  cursor: not-allowed !important;
}

// Hiding OTB widget
// TODO: This is valid just to use Floating widget, remove this to see Out of the Box
// TODO: Check need for a programmatically way to hide widget (js logic)
.otb-widget--hide {
  #sf-widget-companion-wrapper {
    display: none !important;
  }
}
</style>
